"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarView = exports.query = void 0;
var React = __importStar(require("react"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var CalendarTable = __importStar(require("../calendar/components/calendar-table"));
var use_graphql_query_1 = require("../graphql/use-graphql-query");
var appointment_dialog_1 = require("./components/appointment-dialog");
var calendar_filter_1 = require("./components/calendar-filter");
var calendar_id_1 = require("../main/calendar-id");
exports.query = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetCalendars($calendarId: Int!, $year: Int!, $month: Int!) {\n    calendar(calendarId: $calendarId) {\n      ...CalendarTable_Calendar\n    }\n  }\n  ", "\n"], ["\n  query GetCalendars($calendarId: Int!, $year: Int!, $month: Int!) {\n    calendar(calendarId: $calendarId) {\n      ...CalendarTable_Calendar\n    }\n  }\n  ", "\n"])), CalendarTable.fragments.calendar);
function CalendarView(_a) {
    var _b;
    var state = _a.state, dispatch = _a.dispatch, calendarId = _a.calendarId, year = _a.year, month = _a.month;
    var appointmentEditorState = state.appointmentEditorState;
    var _c = (0, use_graphql_query_1.useGraphqlQuery)(exports.query, {
        calendarId: (0, calendar_id_1.getCalendarNumberById)(calendarId),
        year: year,
        month: month,
    }), loadedQuery = _c.loadedQuery, isLoading = _c.isLoading, isError = _c.isError, requery = _c.requery;
    if (!loadedQuery) {
        return React.createElement("div", null, "LOADING...");
    }
    if (isError) {
        return React.createElement("div", null, "ERROR...");
    }
    if (isLoading) {
        console.log("ISLOADING", loadedQuery);
    }
    var resourceFilter = function (resource) {
        return state.filteredResources === undefined
            ? true
            : state.filteredResources.some(function (filteredResource) { return filteredResource.id === resource.id; });
    };
    return (React.createElement("div", null,
        React.createElement("div", null,
            appointmentEditorState && (React.createElement(appointment_dialog_1.AppointmentDialog, { appointmentEditorState: appointmentEditorState, dispatch: dispatch, requery: requery })),
            React.createElement(calendar_filter_1.CalendarFilter, { dispatch: dispatch, filteredResources: state.filteredResources, showFilter: state.showFilter, allResources: ((_b = loadedQuery.response.data) === null || _b === void 0 ? void 0 : _b.calendar.persons) || [], calendarId: calendarId }),
            React.createElement("div", { style: { overflow: "auto" } },
                React.createElement(CalendarTable.CalendarTable, { year: loadedQuery.variables.year, month: loadedQuery.variables.month, calendar: loadedQuery.response.data.calendar, dispatch: dispatch, requery: requery, personFilter: resourceFilter })))));
}
exports.CalendarView = CalendarView;
var templateObject_1;
//# sourceMappingURL=calendar-view.js.map